import { Pipe, PipeTransform } from '@angular/core';
import { getMessageChannelsLabel } from 'src/app/forms/messageForms';
import { MessageChannel } from 'src/app/models/enums';
import { LiteralService } from 'src/app/services/literal/literal.service';

@Pipe({
  name: 'messageChannelsLabel',
})
export class MessageChannelsLabelPipe implements PipeTransform {
  constructor(private literalService: LiteralService) {}

  transform(channels: MessageChannel[] | null | undefined): string {
    return getMessageChannelsLabel(channels ?? [], this.literalService);
  }
}
